import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { CancelAppointment } from "./Components/AppointmentBooking/AppointmentCancellation/CancelAppointment";
import { ConfirmAppointment } from "./Components/AppointmentBooking/AppointmentConfirmation/ConfirmAppointment";
import { AppointmentLanding } from "./Components/AppointmentBooking/AppointmentLanding/AppointmentLanding";
import { OptInBooking } from "./Components/OptInBooking/OptInBooking";
import { OptInBookingConfirmation } from "./Components/OptInBooking/OptInBookingConfirmation";
import { CarePlanConfirmation } from "./Components/CarePlan/CarePlanConfirmation";
import { LightValidation } from "./Components/Validation/LightValidation";
import { OptInBookingInvalid } from "./Components/OptInBooking/OptInBookingInvalid";
import { ValidationError } from "./Components/Validation/ValidationError";
import { QuestionnairePortal } from "./Components/Questionnaires/QuestionnairePortal";
import Questionnaire from "./Components/Questionnaires/Questionnaire/Components/questionnaire";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
    CHUIAppBar,
    CHUIFooter,
    CHUITheme,
    useCHUIDarkModeContext,
    useCHUITextSizeContext,
} from "@connecthealth-ui/core";
import { CssBaseline, Paper } from "@mui/material";
import { useMemo, useEffect } from "react";

function App() {
    const { prefersDarkMode } = useCHUIDarkModeContext();
    const { selectedTextSize } = useCHUITextSizeContext();

    const theme = useMemo(() => {
        return createTheme(CHUITheme(prefersDarkMode, selectedTextSize));
    }, [prefersDarkMode, selectedTextSize]);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* min height in the total view height - footers height*/}
            <Paper square sx={{ minHeight: "calc(100vh - 232px)" }}>
                <CHUIAppBar includeTranslation={includeTranslation()} title={getTitle()} />
                <Router>
                    <Switch>
                        <Route exact path="/Appointments/AppointmentBooking/" component={AppointmentLanding} />
                        <Route
                            exact
                            path="/Appointments/AppointmentBooking/CancelAppointment"
                            component={CancelAppointment}
                        />
                        <Route
                            exact
                            path="/Appointments/AppointmentBooking/ConfirmAppointment"
                            component={ConfirmAppointment}
                        />
                        <Route exact path="/Booking/OptInBooking" component={OptInBooking} />
                        <Route exact path="/Booking/OptInBookingConfirmation" component={OptInBookingConfirmation} />
                        <Route exact path="/Booking/Validate" component={LightValidation} />
                        <Route exact path="/Booking/OptInBookingInvalid" component={OptInBookingInvalid} />
                        <Route exact path="/Questionnaire/QuestionnairePortal" component={QuestionnairePortal} />
                        <Route exact path="/Questionnaire/Questionnaires" component={Questionnaire} />
                        <Route exact path="/CarePlan/Validate" component={LightValidation} />
                        <Route exact path="/Validation/Error" component={ValidationError} />
                        <Route exact path="/CarePlan/Confirmation" component={CarePlanConfirmation} />
                    </Switch>
                </Router>
            </Paper>
            <CHUIFooter />
        </ThemeProvider>
    );
}

export default App;

function getTitle() {
    let pathname = window.location.pathname.toString();
    if (pathname.includes("Appointments") || pathname.includes("Booking")) {
        return "Appointment Booking";
    } else if (pathname.includes("Questionnaire")) {
        return "Digital Assessment";
    } else if (pathname.includes("CarePlan")) {
        return "Care Plan";
    } else if (pathname.includes("Validation")) {
        return "Validation";
    } else {
        return "Patient Portal";
    }
}

function includeTranslation() {
    let pathname = window.location.pathname.toString();
    if (pathname.includes("Questionnaire")) {
        return true;
    }

    return false;
}
